encodedKey